/**
 * 老师专家管理
 */
export default {
  teacherList: "/teacherInfo/selectPageList", // 老师专家列表
  teacherAdd: "/teacherInfo/insert", // 老师专家新增
  teacherEdit: "/teacherInfo/update", // 老师专家修改
  teacherStatus: "/teacherInfo/delete", // 老师专家账号启用停用、删除
}
